import { InvalidGalleryContentError } from '../errors/InvalidGalleryContentError';

export type GalleryItemType = 'image' | 'video';
const VALID_TYPES: GalleryItemType[] = ['image', 'video'];

export interface GalleryItemInput {
  id: string;
  type: GalleryItemType;
  url: string;
  thumbnailUrl: string;
  caption: string;
  albumId: string | null;
  projectId: string | null;
}

/**
 * Entity per the pattern in features/services and features/projects.
 * `albumId`/`projectId` are both nullable and independent — an item can
 * belong to an album, be linked to a project's gallery, both, or neither
 * (e.g. a standalone company photo), per the "Project Gallery" requirement.
 */
export class GalleryItem {
  private constructor(public readonly props: GalleryItemInput) {
    Object.freeze(this.props);
    Object.freeze(this);
  }

  public static create(input: GalleryItemInput): GalleryItem {
    if (!VALID_TYPES.includes(input.type)) {
      throw new InvalidGalleryContentError(`type must be one of: ${VALID_TYPES.join(', ')}.`);
    }
    if (input.url.trim().length === 0) {
      throw new InvalidGalleryContentError('url must not be empty.');
    }
    if (input.thumbnailUrl.trim().length === 0) {
      throw new InvalidGalleryContentError('thumbnailUrl must not be empty.');
    }

    return new GalleryItem(input);
  }
}
